import React, { Component } from 'react';
import Table1 from "./4-5";

class index extends Component {
    render() {
        return (
            <div>
                <Table1 key={1} />
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-5/index.js